import { render, staticRenderFns } from "./BioLinkUpdateModal.vue?vue&type=template&id=e9998746&scoped=true&"
import script from "./BioLinkUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./BioLinkUpdateModal.vue?vue&type=script&lang=ts&"
import style0 from "./BioLinkUpdateModal.vue?vue&type=style&index=0&id=e9998746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9998746",
  null
  
)

export default component.exports